import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "legend" }
const _hoisted_2 = { class: "flex flex-row flex-wrap border-2 border-[#CDE3F4] w-full min-h-[50px] rounded-md min-w-[350px] gap-8 px-8 py-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { id: "graphs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LearningMap = _resolveComponent("LearningMap")!
  const _component_FullModal = _resolveComponent("FullModal")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_FullModal, {
      headerInfo: _ctx.headerInfo,
      onOnClose: _ctx.onCloseMap
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legends, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex items-center gap-2",
                key: i
              }, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: "icon"
                }, null, 8, _hoisted_3),
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_LearningMap, {
            userId: _ctx.user.id,
            courseId: _ctx.idCourse,
            type: 'STUDENT_LEARNING_MAP'
          }, null, 8, ["userId", "courseId"])
        ])
      ]),
      _: 1
    }, 8, ["headerInfo", "onOnClose"])
  ]))
}